import Modal from "react-bootstrap/Modal";
import acknowledgementOfCountryImg from "src/images/modals/acknowledgment-of-country.png";
import * as React from 'react';
export default {
  Modal,
  acknowledgementOfCountryImg,
  React
};